// extracted by mini-css-extract-plugin
module.exports = {"aldebaranLink":"AldebaranLink_aldebaranLink___Ps8V"};